import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IUsageRecordParam, IUsageRecordItem } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 接口用量 - 使用记录 - 获取分页列表
 */
export async function queryUsageRecordPage(params: IUsageRecordParam) {
  let total = 0;
  let data = [] as IUsageRecordItem[];

  try {
    const { code, context, message } = await Http.post<{ data: IUsageRecordItem[]; total: number }>(
      `${hostUrl}/report/infra-api/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as { data: IUsageRecordItem[]; total: number };

      data = res.data || [];
      total = res.total || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 接口用量 - 使用记录 - 导出
 */
export async function exportUsageRecord(params: IUsageRecordParam) {
  let buffer = null as Blob | null;
  let fileName = '';

  try {
    const { code, context, headers, message } = await Http.post<Blob>(
      `${hostUrl}/report/infra-api/export`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

